import clsx from 'clsx';
import React from 'react'

import {classes} from './Accordion.classes'
import {AccordionProps} from './Accordion.types';
import {AccordionItem} from './AccordionItem'

export function Accordion({data, separator, className}: AccordionProps) {
  return (
    <div className={className}>
      {data.map((item, index) => (
        <AccordionItem
          key={index.toString()}
          separator={separator}
          {...item}
          className={clsx({[classes.last]: index === data.length - 1})}
        />
      ))}
    </div>
  )
}
